<template>
    {{{ parsedText }}}
</template>
<script>
const showdown = require('showdown')
const converter = new showdown.Converter()
export default {
    props: {
        text: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            parsedText: null
        }
    },
    ready () {
        this.parseText()
    },
    methods: {
        parseText () {
            if (this.text) {
                this.parsedText = converter.makeHtml(this.text)
            } else {
                this.parsedText = null
            }
        }
    },
    watch: {
        text () {
            this.parseText()
        }
    }
}
</script>


// WEBPACK FOOTER //
// Markdown.vue?ec4d17de